import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      meta: { title: '首页' },
      component: () => import('@/views/home/index.vue')
    },
    {
      path: '/login',
      meta: { title: '登录' },
      component: () => import('@/views/login.vue')
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js